@if ({ mobile: isMobile$ | async, show: show$ | async }; as observables) {
<div class="page-menu-wrapper">
  @if (observables.mobile) {
  <fa-icon
    class="open-menu-icon p-3"
    [icon]="['fas', 'bars']"
    data-e2e="open-page-menu"
    (click)="open()"
  >
  </fa-icon>
  }
  <div
    class="page-menu-items-container pt-lg-3"
    [class.mobile]="observables.mobile"
    [class.show]="observables.show"
  >
    @if (observables.mobile) {
    <span class="w-100 d-flex flex-row justify-content-end">
      <fa-icon
        class="close-menu-icon p-3"
        [icon]="['fas', 'xmark']"
        data-e2e="close-page-menu"
        (click)="close()"
      >
      </fa-icon>
    </span>
    }
    <div
      class="page-menu-items d-flex flex-column flex-md-row"
      [class.wrap]="wrap"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
}
